function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ZoomTemplate = require('./zoom.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ZoomOverlay = /*#__PURE__*/function () {
  function ZoomOverlay(app, mod) {
    _classCallCheck(this, ZoomOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.spaces_onclick_callback = null;
  }
  return _createClass(ZoomOverlay, [{
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "scrollTo",
    value: function scrollTo() {
      var spacekey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var top = 0;
      var left = 0;
      if (spacekey != '') {
        top = this.mod.game.spaces[spacekey].top;
        left = this.mod.game.spaces[spacekey].left;
      }
      return this.scrollToCoordinates(top, left);
    }
  }, {
    key: "scrollToCoordinates",
    value: function scrollToCoordinates() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var zoomOverlay = document.querySelector('.zoom-overlay');
      if (!zoomOverlay) {
        try {
          this.render();
          zoomOverlay = document.querySelector('.zoom-overlay');
        } catch (err) {
          return 0;
        }
      }
      var zoomWidth = zoomOverlay.clientWidth;
      var zoomHeight = zoomOverlay.clientHeight;
      var scrollLeft = left - zoomWidth / 2;
      var scrollTop = top - zoomHeight / 2;
      if (scrollLeft < 0) {
        scrollLeft = 0;
      }
      if (scrollTop < 0) {
        scrollTop = 0;
      }
      var board = document.querySelector('.zoom-overlay .gameboard');
      board.style.left = '0px';
      board.style.top = '0px';
      board.style.transition = 'transform 0.5s ease';
      board.style.transform = "translate(-".concat(scrollLeft, "px, -").concat(scrollTop, "px)");
    }
  }, {
    key: "showControls",
    value: function showControls() {
      var ob1 = document.querySelector('.zoom-overlay .status');
      var ob2 = document.querySelector('.zoom-overlay .controls');
      if (ob1) {
        ob1.style.display = 'block';
      }
      if (ob2) {
        ob2.style.display = 'block';
      }
      this.keepCombatOverlayInFront();
    }
  }, {
    key: "hideControls",
    value: function hideControls() {
      var ob1 = document.querySelector('.zoom-overlay .status');
      var ob2 = document.querySelector('.zoom-overlay .controls');
      if (ob1) {
        ob1.style.display = 'none';
      }
      if (ob2) {
        ob2.style.display = 'none';
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "renderAtSpacekey",
    value: function renderAtSpacekey() {
      var spacekey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      console.log('spacekey: ' + spacekey);
      if (document.querySelector('.zoom-overlay')) {
        this.overlay.show();
      }
      this.visible = true;
      var s = this.mod.game.spaces[spacekey];
      this.renderAtCoordinates(s.top, s.left);
      return 0;
    }
  }, {
    key: "renderAtCoordinates",
    value: function renderAtCoordinates() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!document.querySelector('.zoom-overlay .gameboard')) {
        this.render();
      }
      var zoomOverlay = document.querySelector('.zoom-overlay');
      var board = document.querySelector('.zoom-overlay .gameboard');
      var zoomWidth = zoomOverlay.clientWidth;
      var zoomHeight = zoomOverlay.clientHeight;
      var boardWidth = board.offsetWidth;
      var boardHeight = board.offsetHeight;
      var scrollLeft = left - zoomWidth / 2;
      var scrollTop = top - zoomHeight / 2;

      // keep board
      scrollLeft = Math.max(0, Math.min(scrollLeft, boardWidth - zoomWidth));
      scrollTop = Math.max(0, Math.min(scrollTop, boardHeight - zoomHeight));
      if (scrollLeft < 0) {
        scrollLeft = 0;
      }
      if (scrollTop < 0) {
        scrollTop = 0;
      }

      // funky slide
      board.style.transition = '';
      board.style.transform = "translate(-".concat(scrollLeft, "px, -").concat(scrollTop, "px)");

      // remove status
      var status = document.querySelector('.zoom-overlay .status');
      status.style.display = 'none';
      var controls = document.querySelector('.zoom-overlay .controls');
      controls.style.display = 'none';
      this.attachEvents();
      this.keepCombatOverlayInFront();
    }

    // Next-target zoom is opened while combat results are still up. Keep the
    // combat/loss overlay, and its backdrop, above that zoom layer.
  }, {
    key: "keepCombatOverlayInFront",
    value: function keepCombatOverlayInFront() {
      var zoom = document.querySelector('.zoom-overlay');
      if (!zoom) {
        return;
      }
      var zoom_host = zoom.closest('.saito-overlay');
      if (!zoom_host) {
        return;
      }
      var zoom_z = parseInt(zoom_host.style.zIndex, 10) || 0;
      document.querySelectorAll('.loss-overlay, .combat-overlay').forEach(function (el) {
        var host = el.closest('.saito-overlay');
        if (!host) {
          return;
        }
        var host_z = parseInt(host.style.zIndex, 10) || 0;
        if (host_z <= zoom_z) {
          host.style.zIndex = String(zoom_z + 2);
        }
        var backdrop = document.getElementById(host.id.replace('saito-overlay', 'saito-overlay-backdrop'));
        if (backdrop) {
          var backdrop_z = parseInt(backdrop.style.zIndex, 10) || 0;
          if (backdrop_z <= zoom_z) {
            backdrop.style.zIndex = String(zoom_z + 1);
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.pushHudUnderOverlay();

      //
      // if already visible, don't reload
      //
      if (this.visible == true) {
        if (document.querySelector('.zoom-overlay')) {
          return;
        }
      }
      this.visible = true;
      this.overlay.show(ZoomTemplate());
      var dw = document.querySelector('.zoom-overlay');
      var gb = this.mod.getBoardElement();
      if (!gb) {
        return;
      }
      var gb2 = gb.cloneNode(true);
      gb2.removeAttribute('id');
      gb2.removeAttribute('style');
      gb2.classList.add('gameboard-clone');
      dw.appendChild(gb2);
      $('.gameboard-clone').draggable({});
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var _loop = function _loop(key) {
        var qs = '.zoom-overlay .gameboard .' + key;
        if (!document.querySelector(qs)) {
          console.log('qs: ' + qs);
        } else {
          document.querySelector(qs).onclick = function (e) {
            var space_id = e.currentTarget.id;
            //
            // we have clicked on a space. if there is a callback attached to the
            // zoom overlay, we are going to execute that callback. this is used
            // when we want people to use the zoom overlay to select something.
            //
            if (_this.spaces_onclick_callback != null) {
              //
              // trigger if selectable
              //
              var can_trigger = false;
              var tkey = ".".concat(key);
              document.querySelectorAll(tkey).forEach(function (el) {
                if (el.classList.contains('selectable')) {
                  can_trigger = true;
                }
              });
              if (can_trigger) {
                _this.spaces_onclick_callback(space_id);
              }

              //
              // otherwise we will show the detailed VIEW of the space, since people
              // are trying to click on a space but it isn't selectable, which means
              // letting them see for themselves what is heree.
              //
            } else {
              console.log('ID: ' + space_id);
              _this.mod.displaySpaceDetailedView(space_id);
            }
          };
        }
      };
      //
      // add tiles
      //
      for (var key in this.mod.game.spaces) {
        _loop(key);
      }
    }
  }]);
}();
module.exports = ZoomOverlay;